module.exports = __webpack_public_path__ + "img/postepay.070de4ff.png";